import { Box, Checkbox, Text, VStack } from '@chakra-ui/react'
import { FieldMapValue } from '@hb/shared'
import { SectionLabel } from '../../SectionLabel'

const LabelText = ({ label }: { label: string }) => (
  <Text fontSize="xs" fontWeight={600} color="gray.500" _dark={{ color: 'gray.400' }} mb={0.5}>
    {label}
  </Text>
)

const referralLabels: Record<string, string> = {
  cessation: 'Cessation program',
  'substance-use-counselor': 'Substance use counselor',
  'patient-declined': 'Patient declined referral',
}

export const SubstanceUseCounselingView = ({ data }: { data: FieldMapValue }) => {
  const counseling = data?.substanceUseCounseling as
    | {
        addressed?: boolean
        tobaccoScreened?: boolean
        substanceUseScreened?: boolean
        result?: string
        counselingProvided?: boolean
        counselingMinutes?: number
        referral?: string
        dismissedReason?: string
      }
    | undefined

  if (!counseling) return null

  const {
    addressed,
    tobaccoScreened,
    substanceUseScreened,
    result,
    counselingProvided,
    counselingMinutes,
    referral,
    dismissedReason,
  } = counseling

  return (
    <VStack align="flex-start" spacing={2} w="100%">
      <SectionLabel>Substance Use & Tobacco Counseling</SectionLabel>

      {addressed === false && (
        <Text fontSize="sm" color="gray.500" _dark={{ color: 'gray.400' }}>
          Not addressed today
          {dismissedReason ? ` — ${dismissedReason}` : ''}
        </Text>
      )}

      {addressed === true && (
        <VStack align="flex-start" spacing={1.5} w="100%">
          {tobaccoScreened != null && (
            <Checkbox isChecked={tobaccoScreened} isReadOnly size="sm">
              <Text fontSize="sm">Tobacco use screened</Text>
            </Checkbox>
          )}
          {substanceUseScreened != null && (
            <Checkbox isChecked={substanceUseScreened} isReadOnly size="sm">
              <Text fontSize="sm">Substance use screened</Text>
            </Checkbox>
          )}
          {result && (
            <Box>
              <LabelText label="Findings" />
              <Text fontSize="sm">{result}</Text>
            </Box>
          )}
          {counselingProvided != null && (
            <Checkbox isChecked={counselingProvided} isReadOnly size="sm">
              <Text fontSize="sm">
                Counseling provided
                {counselingProvided && typeof counselingMinutes === 'number'
                  ? ` (${counselingMinutes} min)`
                  : ''}
              </Text>
            </Checkbox>
          )}
          {referral && (
            <Box>
              <LabelText label="Referral" />
              <Text fontSize="sm">{referralLabels[referral] ?? referral}</Text>
            </Box>
          )}
        </VStack>
      )}
    </VStack>
  )
}
